<template>
  <div class="mul">
    <!-- <div :style="{ marginBottom: '16px' }">
      <a-button @click="add">
        ADD
      </a-button>
    </div> -->
	<a-dropdown :trigger="['contextmenu']">
	   <a-tabs  @contextmenu.prevent="rightEvent($event,panes)" v-if="Authorization" @tabClick="tabClick" style="height: 39.5px !important;width:98% !important;margin: 0 auto;" v-model="activeKey" hide-add type="editable-card" @edit="onEdit">
	   	
	     <a-tab-pane  v-for="pane in panes" :key="pane.key" :tab="pane.title" :closable="pane.closable">
	      <!-- {{ pane.content }} -->
	     </a-tab-pane>
	   </a-tabs>
	    <a-menu slot="overlay" v-if="targetItem">
	      <a-menu-item v-if="onlyCacheBtn==false">
	        <a @click="openCacheOnly" href="javascript:;"><a-icon style="margin-right: 10px;" type="play-circle" />开启独立缓存</a>
	      </a-menu-item>
	     <a-menu-item v-if="onlyCacheBtn==true">
	       <a @click="closeCacheOnly" href="javascript:;"><a-icon  style="margin-right: 10px;" type="close-circle" />关闭独立缓存</a>
	     </a-menu-item>
	    </a-menu>
	  </a-dropdown>
    
	<div v-if="Authorization" style="position: absolute;right: 12px;top: 185px;cursor: pointer;">
		<a-dropdown>
		    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
		     <a-icon style="color: black;font-size: 14px;" type="down" />
		    </a>
		    <a-menu slot="overlay" >
		      <a-menu-item>
		        <a @click="closeLeft"><a-icon style="margin-right: 10px;" type="arrow-left" />关闭左侧标签</a>
		      </a-menu-item>
		      <a-menu-item>
		        <a @click="closeRight" href="javascript:;"><a-icon style="margin-right: 10px;" type="arrow-right" />关闭右侧标签</a>
		      </a-menu-item>
		      <a-menu-item>
		        <a @click="closeOrder" href="javascript:;"><a-icon style="margin-right: 10px;" type="close" />关闭其他标签</a>
		      </a-menu-item>
			  <!--v-if="cache=='close'||!cache" v-if="cache=='open'" -->
			  <a-menu-item >
			    <a @click="openCache" href="javascript:;"><a-icon style="margin-right: 10px;" type="play-circle" />开启全部缓存</a>
			  </a-menu-item>
			  <a-menu-item >
			    <a @click="closeCache" href="javascript:;"><a-icon  style="margin-right: 10px;" type="close-circle" />关闭全部缓存</a>
			  </a-menu-item>
			  <a-menu-item >
			    <a  href="javascript:;"><a-icon  style="margin-right: 10px;" type="exclamation-circle" />Tips:标签右键</a>
			  </a-menu-item>
			  <!-- <a-menu-item>
			    <a href="javascript:;"><a-icon style="margin-right: 10px;" type="close-circle" />关闭全部</a>
			  </a-menu-item> -->
		    </a-menu>
		  </a-dropdown>
		
		
	</div>
  </div>
</template>
<script>
export default {
  data() {
    const panes =  [
      { title: '首页', key: '/',id:0 , onlyCache:false },
    ];
    return {
	targetItem:{},
      activeKey: panes[0].key,
	  cache:window.sessionStorage.getItem('cache'),
	  onlyCacheBtn:false,
      panes,
	  Authorization:window.localStorage.getItem('Authorization'),
	  fullPathList:JSON.parse(window.sessionStorage.getItem('fullPathList'))?JSON.parse(window.sessionStorage.getItem('fullPathList')):['/'],
      newTabIndex: window.sessionStorage.getItem('newTabIndex')?window.sessionStorage.getItem('newTabIndex'):0,
    };
  },
 watch: {
     '$route': function (newVal) {
		 if(this.Authorization){
			 this.activeKey = newVal.fullPath
			 		
			  if (this.fullPathList.indexOf(newVal.fullPath) < 0) {
			      const panes = this.panes;
			 			  const activeKey = ++this.newTabIndex;
			      panes.push({
			        title: newVal.meta.title,
			        key: newVal.fullPath,
			 		id:activeKey,
					onlyCache:false
			      })
			 			  this.fullPathList.push(newVal.fullPath)
			      this.panes = panes;
			 			  window.sessionStorage.setItem('fullPathList',JSON.stringify(this.fullPathList))
			 			  window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
			 			   window.sessionStorage.setItem('newTabIndex',this.newTabIndex)
			    }
		 }
		
     },
     activeKey: function (newPathKey) {
       this.$router.push({ path: newPathKey })
     }
   },
   created() {
   	this.panes = JSON.parse(window.sessionStorage.getItem('panes'))?JSON.parse(window.sessionStorage.getItem('panes')):[
      { title: '首页', key: '/',id:0 ,onlyCache:false},
    ]
   },
  methods: {
    callback(key) {
      console.log(key);
    },
	relocadCache(){
		this.Authorization = window.localStorage.getItem('Authorization')
	},
    onEdit(targetKey, action) {
      this[action](targetKey);
    },
    // add() {
    //   const panes = this.panes;
    //   const activeKey = `newTab${this.newTabIndex++}`;
    //   panes.push({
    //     title: `New Tab ${activeKey}`,
    //     content: `Content of new Tab ${activeKey}`,
    //     key: activeKey,
    //   });
    //   this.panes = panes;
    //   this.activeKey = activeKey;
    // },
    remove(targetKey) {
		if (this.fullPathList.length <= 1) {
		    this.$message.info('这是最后一个标签了, 无法被关闭')
			return
		} 
      let activeKey = this.activeKey;
      let lastIndex;
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      const panes = this.panes.filter(pane => pane.key !== targetKey);
	  const fullPathList = this.fullPathList.filter(fullPath => fullPath !== targetKey);
      if (panes.length && activeKey === targetKey) {
        if (lastIndex >= 0) {
          activeKey = panes[lastIndex].key;
        } else {
          activeKey = panes[0].key;
        }
      }
      this.panes = panes;
      this.activeKey = activeKey;
	  this.fullPathList = fullPathList;
	  window.sessionStorage.setItem('fullPathList',JSON.stringify(this.fullPathList))
	  window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
    },
	closeLeft(){
		let ids
		this.panes.map((n)=>{
			if(n.key==this.activeKey){
				ids = n.id
			}
		})
		const panes = this.panes.filter(pane => pane.id >= ids);
		const fullPathList = panes.map((n)=>{
			return n.key
		})
		this.panes = panes;
		this.fullPathList = fullPathList
		 window.sessionStorage.setItem('fullPathList',JSON.stringify(this.fullPathList))
		 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
	},
	closeRight(){
		let ids
		this.panes.map((n)=>{
			if(n.key==this.activeKey){
				ids = n.id
			}
		})
		const panes = this.panes.filter(pane => pane.id <= ids);
		const fullPathList = panes.map((n)=>{
			return n.key
		})
		this.panes = panes;
		this.fullPathList = fullPathList
		 window.sessionStorage.setItem('fullPathList',JSON.stringify(this.fullPathList))
		 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
	},
	tabClick(data){
		console.log(data)
	},
	rightEvent(key,data){
		// console.log(key.target.outerText)
		// console.log(data)
		let targetItem = data.filter((n)=>n.title==key.target.outerText)[0]
		this.targetItem = targetItem
		this.onlyCacheBtn = targetItem.onlyCache
		// console.log(targetItem)
	},
	openCacheOnly(){
		this.targetItem.onlyCache = !this.targetItem.onlyCache
		 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
		this.$message.success("已开启该页面独立缓存")
		 location.reload()
	},
	closeCacheOnly(data){
		this.targetItem.onlyCache = !this.targetItem.onlyCache
	 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
	 this.$message.success("已关闭该页面独立缓存")
	  location.reload()
	},
	closeOrder(){
		let ids
		this.panes.map((n)=>{
			if(n.key==this.activeKey){
				ids = n.id
			}
		})
		const panes = this.panes.filter(pane => pane.id == ids);
		const fullPathList = panes.map((n)=>{
			return n.key
		})
		this.panes = panes;
		this.fullPathList = fullPathList
		 window.sessionStorage.setItem('fullPathList',JSON.stringify(this.fullPathList))
		 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
		
	},
	openCache(){
		this.panes =  this.panes.map((n)=>{
			return {
				id: n.id,
				key: n.key,
				title:n.title,
				onlyCache: true
			}
		})
		console.log(this.panes)
		window.sessionStorage.setItem('cache','open')
		 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
		this.$message.success("已开启所有页面缓存")
		 location.reload()
		  
	},
	closeCache(){
		this.panes =  this.panes.map((n)=>{
			return {
				id: n.id,
				key: n.key,
				title:n.title,
				onlyCache: false
			}
		})
		console.log(this.panes)
		window.sessionStorage.setItem('cache','close')
		 window.sessionStorage.setItem('panes',JSON.stringify(this.panes))
		this.$message.success("已关闭所有页面缓存")
		 location.reload()
		 
	},
  },
};
</script>
<style>
	.mul .ant-tabs-tab-btn-disabled{
		width: 15px !important;
		    height: 100% !important;
		    opacity: 1 !important;
		    pointer-events: auto !important; 
			
	}
	/* .mul .ant-tabs-tab-prev{
		left: -15px;
	} */
	/* .mul .ant-tabs-nav-container-scrolling {
	    padding-right: 32px !important;
	    padding-left: 32px !important;
	} */
	.mul .ant-tabs{
		padding-right: 20px !important;
	}
	.mul .ant-tabs-nav-container{
		padding-right: 32px !important;
		    padding-left: 32px !important;
	}
</style>